export enum WidgetId {
  ArticlesAsidePromotedGameV3 = 'widget-articles-aside-promoted-game-v3',
  ArticlesBannersV3 = 'widget-articles-banners-v3',
  GeneratorDropdownActiveV3 = 'widget-generator-dropdown-active-v3',
  GeneratorDropdownV3 = 'widget-generator-dropdown-v3',
  GeneratorGenderV3 = 'widget-generator-gender-v3',
  GeneratorGlobalV3 = 'widget-generator-global-v3',
  GeneratorV3 = 'widget-generator-v3',
  GlobalStaticV3 = 'widget-global-static-v3',
  LogoMakerEditorOptionsV3 = 'widget-logo-maker-editor-options-v3',
  LogoMakerEditorV3 = 'widget-logo-maker-editor-v3',
  LogoMakerHomeContentV3 = 'widget-logo-maker-home-content-v3',
  LogoMakerHomeGalleryV3 = 'widget-logo-maker-home-gallery-v3',
  LogoMakerThankYouRaidIdV3 = 'widget-logo-maker-thank-you-raid-id-v3',
}
